function isResponse(value: unknown): value is Response {
  return typeof Response !== "undefined" && value instanceof Response;
}

function normalizeMessage(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export async function getSupabaseFunctionErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
): Promise<string> {
  if (!error) {
    return fallback;
  }

  const errorMessage =
    typeof error === "object" && error !== null && "message" in error
      ? normalizeMessage((error as { message?: unknown }).message)
      : normalizeMessage(error);

  const context =
    typeof error === "object" && error !== null && "context" in error
      ? (error as { context?: unknown }).context
      : null;

  if (isResponse(context)) {
    try {
      const response = context.clone();
      const contentType = response.headers.get("content-type") || "";

      if (contentType.includes("application/json")) {
        const payload = await response.json();
        const jsonError =
          normalizeMessage(payload?.error) ||
          normalizeMessage(payload?.message) ||
          normalizeMessage(payload?.details);

        if (jsonError) {
          return jsonError;
        }
      }

      const text = normalizeMessage(await response.text());
      if (text) {
        return text;
      }
    } catch (parseError) {
      console.error("Failed to parse Supabase function error response:", parseError);
    }
  }

  if (errorMessage && !/non-2xx status code/i.test(errorMessage)) {
    return errorMessage;
  }

  return fallback;
}
